import React from "react";
import svg50 from "../../../assets/svg/svg50.svg";
import svg51 from "../../../assets/svg/svg51.svg";
import svg52 from "../../../assets/svg/svg52.svg";

function PersonalSecurity() {
  return (
    <div className="flex lg:flex-row flex-col gap-y-[2rem] lg:gap-[3rem] lg:items-center justify-between text-white">
      <div className="flex flex-col w-full lg:max-w-[50%]">
        <div className="text-[1.5rem] md:text-[1.875rem] font-[600] leading-tight md:leading-[2.25rem] max-w-full lg:max-w-[35rem] w-full">
          Your Money. Fully Protected.
        </div>
        <div className="mt-[.75rem] text-[1rem] font-[400] leading-[1.625rem] max-w-full lg:max-w-[30rem] w-full">
          Impala Digital Payments uses enterprise-grade encryption and complies with Central
          Bank and Data Protection regulations. Every transaction is verified,
          receipted, and visible only to you.
        </div>
        <div className="mt-[1.5rem] flex lg:flex-row flex-col gap-[.75rem] flex-wrap">
          <button className="cstm-btn-dark w-full sm:w-auto">
            <img src={svg50} alt="svg50" className="flex-shrink-0" />{" "}
            <span className="whitespace-nowrap">PCI‑DSS Ready</span>
          </button>

          <button className="cstm-btn-dark w-full sm:w-auto">
            <img src={svg51} alt="svg51" className="flex-shrink-0" />{" "}
            <span className="whitespace-nowrap">ISO 27001 Practices</span>
          </button>

          <button className="cstm-btn-dark w-full sm:w-auto">
            <img src={svg52} alt="svg52" className="flex-shrink-0" />{" "}
            <span className="whitespace-nowrap">99.95% Uptime</span>
          </button>
        </div>
      </div>

      <div className="flex lg:flex-row flex-col gap-[1rem] w-full lg:w-auto">
        <div className="rounded-[1.25rem] bg-[rgba(255,255,255,0.05)] shadow-[0_0_0_1px_rgba(255,255,255,0.10)] w-full lg:w-[16.75rem] p-[1.25rem] flex flex-col">
          <span className="text-[.875rem] font-[400] leading-[1.5rem]">
            Authentication
          </span>
          <span className="mt-[.25rem] text-[1.875rem] font-[600] leading-[2.25rem]">
            2FA
          </span>
          <span className="mt-[.25rem] text-muted font-[400] text-[.75rem] leading-[1rem]">
            Secure Transactions
          </span>
        </div>

        <div className="rounded-[1.25rem] bg-[rgba(255,255,255,0.05)] shadow-[0_0_0_1px_rgba(255,255,255,0.10)] w-full lg:w-[16.75rem] p-[1.25rem] flex flex-col">
          <span className="text-[.875rem] font-[400] leading-[1.5rem]">
            Fraud Protection
          </span>
          <span className="mt-[.25rem] text-[1.875rem] font-[600] leading-[2.25rem]">
            24/7
          </span>
          <span className="mt-[.25rem] text-muted font-[400] text-[.75rem] leading-[1rem]">
            Real-time Detection
          </span>
        </div>
      </div>
    </div>
  );
}

export default PersonalSecurity;
